module.exports = __webpack_public_path__ + "img/ico-digital-platform_3.3f01318f.svg";